export default __webpack_public_path__ + "static/media/mobileLeaves.c64c0689.png";